export const SERVER_URI = "https://profile-server.shashwatsagar.in";
